import {AirlineTheme} from "../../services/theme/interfaces/airline.theme";

export function getPageVerticalGap(theme: AirlineTheme) {
    return theme.spacing.spacing24;
}